<div *ngIf="!cart" class="container page-top">
  <div class="row justify-content-center">
    <app-spinner [size]="2"></app-spinner>
  </div>
</div>
<div *ngIf="cart" class="container page-top mb-5">
  <h4 class="d-none d-print-block">
    University of Utah - Office of Software Licensing<br/>
  </h4>
  <div *ngIf="purchaseOrderPending">
    <h1 class="mb-5">Pending UShop Purchase Order Receipt</h1>
    <p class="mb-4">You must submit a Purchase Order through the UShop Marketplace to complete
      your order. Please see Submitting a Purchase Order below for more details.</p>
  </div>
  <div *ngIf="!purchaseOrderPending">
    <h1 class="mb-5">Order Summary</h1>
    <h4 class="mb-4">Thank you for your order!</h4>
  </div>

  <div class="p-3 mb-3 border border-dark">
    <div class="row">
      <div class="col">
        <h2>
          <span class="me-4">Order #: {{ cart?.id }}</span>
          <app-cart-status-badge [cartStatus]="cart?.status"></app-cart-status-badge>
        </h2>
        <div class="pb-1 history-date">{{ cart?.statusDate |date: 'medium' }}</div>
        <h6>Please print or save a copy of this summary for your records.</h6>
      </div>
    </div>
  </div>
  <br/>

  <div class="row">
    <div class="col-12 col-md-8">
      <div *ngFor="let item of items">
        <app-cart-item [lineItem]="item" [editable]="false"></app-cart-item>
      </div>
      <h1 *ngIf="!hasItems">Loading cart items ...</h1>
    </div>

    <div class="col-12 col-md-4">
      <app-total *ngIf="cart" [cart]="cart"></app-total>
      <br>
      <button *ngIf="!purchaseOrderPending" class="btn btn-dark my-1 col-12 d-print-none" (click)="printPage()">Print
        Order Summary
      </button>
      <button *ngIf="purchaseOrderPending" class="btn btn-dark my-1 col-12 py-3 d-print-none"
              (click)="swapToCreditCard(cart)">Pay with Credit Card/PCard Instead
      </button>
    </div>
  </div>

  <div *ngIf="!purchaseOrderPending" class="my-5">
    <h2 class="">Available Downloads</h2>
    <app-download-list [downloadItems]="downloads"></app-download-list>
  </div>
  <div *ngIf="displayNotes" class="my-5">
    <h2>Notes</h2>
    <div *ngIf="hasComments" class="row">
      <h4 class="col-12 col-md-4">From Customer</h4>
      <p class="col-12 col-md-8 preserve-spacing">{{ cart?.comments }}</p>
    </div>
    <div *ngIf="hasOslComments" class="row">
      <h4 class="col-12 col-md-4">From OSL</h4>
      <p class="col-12 col-md-8 preserve-spacing">{{ cart?.publicOslComments }}</p>
    </div>
  </div>
  <div *ngIf="!purchaseOrderPending && hasItems" class="my-5">
    <h2 class="">Installation Directions</h2>
    <app-install-directions *ngFor="let item of itemsWithPositiveQuantity"
                            [offer]="item.offering"
                            [product]="item.product"></app-install-directions>
  </div>
  <div *ngIf="purchaseOrderPending" class="my-5">
    <div class="row">
      <h2 class="col-12 col-lg-4">Submitting a Purchase Order</h2>
      <ol class="col-12 col-lg-8 ps-5">
        <li>Go to the <a href="http://ushop.utah.edu/" target="_blank">University of Utah's Purchasing site</a>.</li>
        <li>On the Purchasing home page, click the link to UShop Marketplace Login.</li>
        <li>Enter your UNID and password. Click the Login button.</li>
        <li>From the Shopping Dashboard, click on the "OSL (Office of Software Licensing)" link in the Internal Supplier
          Forms box on the right.
        </li>
        <li>On the OSL Software Purchase supplier form page, add the order number found at the top of this page to the
          "OSL Order #" field.
        </li>
        <li>Add the total found at the top of this page to the "OSL Order Total Amount" field.</li>
        <li>On the OSL Software Purchase supplier form, select "Add and go to Cart" from the dropdown on the top right
          and click the Go button.
        </li>
        <li>Submit your order.</li>
      </ol>
    </div>
    <div class="row">
      <p class="col-12 offset-lg-4 col-lg-8 ps-3">
        <strong>You will receive an email when your order has been approved by OSL. Product keys (serial numbers),
          license and installation files will be provided either on your email confirmation or you can access the
          information by viewing your Order History.</strong>
      </p>
    </div>
  </div>
  <div class="my-5" *ngIf="hasDownloadAvailableWithoutPurchase">
    <div class="row">
      <h2 class="col-12 col-lg-4">Other Installation Instructions</h2>
      <p class="col-12 col-lg-8">If someone other than the purchaser will be assigned the license(s) above, installation
        files and
        other documentation can be downloaded by following these steps:</p>
    </div>
    <div class="row">
      <ol class="col-12 offset-lg-4 col-lg-8 ps-5">
        <li>Log in to <a href="https://software-catalog.app.utah.edu/" target="_blank">Software Catalog</a>.</li>
        <li>On the Software Catalog home page, navigate to the "Need Installation Files for Your License?" section
          and click the ‘Installation Files’ button.
        </li>
        <li>From the list of software products on the page, navigate to the item purchased and click links for
          files desired. Please be sure to download the version of the application listed on your receipt.
          License numbers/keys may not work between different versions.
        </li>
        <li>Install and register products with the provided authentication materials.</li>
      </ol>
    </div>
  </div>

  <app-make-payment [uccpConfig]="uccpConfig" [cart]="cart" [submitPayment]="submitPayment"></app-make-payment>
</div>
